import chipPlaceUrl from '../assets/audio/chip-place.mp3?url'
import wheelSpinUrl from '../assets/audio/wheel-spin.mp3?url'
import roundWinUrl from '../assets/audio/round-win.mp3?url'
import roundLossUrl from '../assets/audio/round-loss.mp3?url'

export type RouletteSoundKey = 'chipPlace' | 'wheelSpin' | 'roundWin' | 'roundLoss'

const SFX_DEFAULT_VOLUME = 0.5

export class SoundManager {
	private static _instance: SoundManager | null = null
	private isMuted = false
	private loaded = false
	private volume = SFX_DEFAULT_VOLUME
	private wheelSpinAudio: HTMLAudioElement | null = null
	private readonly sources: Record<RouletteSoundKey, string> = {
		chipPlace: chipPlaceUrl,
		wheelSpin: wheelSpinUrl,
		roundWin: roundWinUrl,
		roundLoss: roundLossUrl,
	}

	static get instance() {
		if (!this._instance) {
			this._instance = new SoundManager()
		}

		return this._instance
	}

	async load() {
		if (this.loaded) {
			return
		}

		await Promise.all(
			Object.values(this.sources).map(
				(src) =>
					new Promise<void>((resolve) => {
						const audio = new Audio(src)
						audio.preload = 'auto'
						audio.oncanplaythrough = () => resolve()
						audio.onerror = () => resolve()
					}),
			),
		)

		this.wheelSpinAudio = new Audio(this.sources.wheelSpin)
		this.wheelSpinAudio.preload = 'auto'
		this.wheelSpinAudio.volume = this.volume

		this.loaded = true
	}

	play(key: RouletteSoundKey) {
		if (this.isMuted) {
			return
		}

		const src = this.sources[key]
		if (!src) {
			return
		}

		try {
			if (key === 'wheelSpin') {
				if (!this.wheelSpinAudio) {
					this.wheelSpinAudio = new Audio(src)
					this.wheelSpinAudio.preload = 'auto'
				}
				this.wheelSpinAudio.volume = this.volume
				this.wheelSpinAudio.currentTime = 0
				void this.wheelSpinAudio.play().catch(() => undefined)
				return
			}

			const audio = new Audio(src)
			audio.volume = this.volume
			void audio.play().catch(() => undefined)
		} catch {
			// Audio unavailable.
		}
	}

	stop(key: RouletteSoundKey) {
		if (key !== 'wheelSpin' || !this.wheelSpinAudio) {
			return
		}

		this.wheelSpinAudio.pause()
		this.wheelSpinAudio.currentTime = 0
	}

	stopAll() {
		this.stop('wheelSpin')
	}

	mute() {
		this.isMuted = true
		this.stopAll()
	}

	unmute() {
		this.isMuted = false
	}
}
